import React from "react";
import styled from "styled-components";

const Main = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const Title = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
  font-size: 0.7em;
`;
const InfoIcon = styled.div`
  margin-right: 2px;
  position: absolute;
  left: 3px;
  font-size: 1em;
`;
const Content = styled.div`
  display: flex;
  height: 100%;
  font-size: 1.2em;
  align-items: center;
  justify-content: center;
`;

export default function MatchMomentum({ previewGraphic, game, allOptaEvents }) {
  return (
    <Main
      onClick={() => {
        previewGraphic("MatchMomentum", {
          game,
          opta_events: allOptaEvents,
        });
      }}
    >
      <Title>
        <InfoIcon>GFX</InfoIcon>
        Match Momentum
      </Title>
      <Content>PREVIEW</Content>
    </Main>
  );
}
